import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHammer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHammer"><Path d="M0.5 11.5L10 2H15L17.5 4.5L5.5 16.5L0.5 11.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18.5 22L10.25 13.75L13.75 10.25L22 18.5L18.5 22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHammer;
